import React from 'react';
import { FaLaptopCode, FaUsers, FaGlobe, FaRocket, FaHome, FaClock, FaTasks, FaSmile, FaEnvelopeOpenText, FaHandshake } from 'react-icons/fa';
import Header from './Header';
import MainHeader from './MainHeader';
import Footer from './Footer';
import SEOHelmet from './SEOHelmet';

const Career = () => {
    // Keep this commented out for when you have openings again
    const jobs = [];

    const perksWithIcons = [
        { icon: <FaHome />, text: "Work From Anywhere" },
        { icon: <FaClock />, text: "Flexible Timings" },
        { icon: <FaTasks />, text: "Industrial Projects & Clients" },
        { icon: <FaSmile />, text: "Friendly Work Culture" },
        { icon: <FaEnvelopeOpenText />, text: "Letter of Recommendation" },
        { icon: <FaHandshake />, text: "Pre-Placement Offer (PPO)" },
    ];

    const whyJoin = [
        { icon: <FaLaptopCode />, title: "Tech-Driven Team" },
        { icon: <FaUsers />, title: "Collaborative Culture" },
        { icon: <FaGlobe />, title: "Global Clients" },
        { icon: <FaRocket />, title: "Rapid Growth" },
    ];

    return (
        <>
            <Header />
            <MainHeader />
            <SEOHelmet
                title="Careers at Octalbees – Join Our Team"
                description="Explore career opportunities at Octalbees. Join our remote-first team of developers, designers, and marketers building the future of digital technology."
                path="/careers"
            />

            <div className="career-page-themed">
                {/* Background Ambient Glows */}
                <div className="career-ambient career-ambient-1"></div>
                <div className="career-ambient career-ambient-2"></div>

                {/* Hero Section */}
                <section className="career-hero">
                    <div className="container text-center">
                        <span className="career-chip">Join The Hive</span>
                        <h1 className="career-hero-title">Build The Future With <span className="career-hero-accent">Octalbees</span></h1>
                        <p className="career-hero-subtitle text-center">We are looking for passionate builders, designers, and marketers to join our remote-first team.</p>
                    </div>
                </section>

                {/* Why Join Octalbees */}
                <section className="why-join-section">
                    <div className="container">
                        <h2 className="section-title">Why Join Octalbees?</h2>
                        <div className="row text-center g-4">
                            {whyJoin.map((item, i) => (
                                <div className="col-lg-3 col-md-6" key={i}>
                                    <div className="why-join-card h-100">
                                        <div className="why-join-icon">{item.icon}</div>
                                        <h5 className="why-join-title">{item.title}</h5>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Current Openings Section */}
                <section className="job-listings-section">
                    <div className="container">
                        <h2 className="section-title">Current Openings</h2>
                        <div className="job-listings-container">
                            {jobs.length > 0 ? (
                                jobs.map((job, i) => (
                                    <div className="job-card" key={i}>
                                        <div className="job-card-header">
                                            <h4 className="job-title">{job.title}</h4>
                                            <span className="job-location">{job.location}</span>
                                        </div>
                                        <p className="job-desc">{job.desc}</p>
                                        <a
                                            href="https://forms.gle/a6ie3JcyuMpZ9Sb97"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="job-apply-button"
                                        >
                                            Apply Now
                                        </a>
                                    </div>
                                ))
                            ) : (
                                <div className="no-openings-card">
                                    <div className="no-openings-icon">
                                        <FaRocket />
                                    </div>
                                    <h3 className="no-openings-title">No Current Openings</h3>
                                    <p className="no-openings-desc text-center">
                                        We do not have any full-time openings as of now. 
                                        However, we're always excited to connect with talented people.
                                    </p>
                                    <p className="no-openings-contact text-center">
                                        Drop your resume at <a href="mailto:hr@octalbees.com">hr@octalbees.com</a> and we'll reach out when a role opens up!
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </section>

                {/* Perks Section */}
                <section className="perks-section">
                    <div className="container">
                        <h2 className="section-title">Perks & Benefits</h2>
                        <div className="row g-4 justify-content-center">
                            {perksWithIcons.map(({ icon, text }, i) => (
                                <div className="col-lg-4 col-md-6" key={i}>
                                    <div className="perk-card h-100">
                                        <div className="perk-icon">{icon}</div>
                                        <p className="perk-text">{text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
            <Footer />

            <style>{`
                /* =============================================
                   CAREER PAGE - PREMIUM LAYOUT (DARK THEME)
                   ============================================= */
                .career-page-themed {
                    background-color: #0c001f;
                    font-family: 'Poppins', sans-serif;
                    position: relative;
                    overflow: hidden;
                    color: #fff;
                }

                /* Ambient Glows */
                .career-ambient {
                    position: absolute;
                    border-radius: 50%;
                    filter: blur(120px);
                    opacity: 0.3;
                    pointer-events: none;
                    z-index: 0;
                }
                .career-ambient-1 {
                    width: 400px; height: 400px;
                    background: #a04ff4;
                    top: -100px; left: -5%;
                    animation: drift 14s ease-in-out infinite alternate;
                }
                .career-ambient-2 {
                    width: 300px; height: 300px;
                    background: #feb52b;
                    top: 40%; right: -5%;
                    animation: drift 11s ease-in-out infinite alternate-reverse;
                }
                @keyframes drift {
                    from { transform: translate(0, 0) scale(1); }
                    to   { transform: translate(30px, 40px) scale(1.1); }
                }

                /* Hero Section */
                .career-hero {
                    padding: 100px 0 60px;
                    position: relative;
                    z-index: 2;
                }
                .career-chip {
                    display: inline-block;
                    padding: 8px 24px;
                    background: rgba(160, 79, 244, 0.12);
                    border: 1px solid rgba(160, 79, 244, 0.3);
                    border-radius: 50px;
                    font-size: 0.9rem;
                    font-weight: 600;
                    color: #c084fc;
                    margin-bottom: 24px;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                }
                .career-hero-title {
                    font-size: 3.5rem;
                    font-weight: 800;
                    margin-bottom: 20px;
                    letter-spacing: -1px;
                    line-height: 1.2;
                }
                .career-hero-accent {
                    background: linear-gradient(135deg, #a04ff4, #feb52b);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                .career-hero-subtitle {
                    font-size: 1.15rem;
                    color: #9ca3af;
                    max-width: 600px;
                    margin: 0 auto;
                    letter-spacing: 0.5px;
                    word-spacing: 1px;
                    line-height: 1.6;
                }

                .section-title {
                    text-align: center;
                    font-weight: 700;
                    margin-bottom: 3.5rem;
                    color: #fff;
                    font-size: 2.5rem;
                    letter-spacing: -0.5px;
                    position: relative;
                    z-index: 2;
                }

                /* --- Why Join Octalbees Section --- */
                .why-join-section {
                    padding: 60px 0 80px;
                    position: relative;
                    z-index: 2;
                }
                .why-join-card {
                    padding: 40px 20px;
                    border: 1px solid rgba(255, 255, 255, 0.05);
                    border-radius: 20px;
                    background: linear-gradient(145deg, rgba(36, 20, 60, 0.4) 0%, rgba(16, 5, 30, 0.8) 100%);
                    backdrop-filter: blur(10px);
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    min-height: 220px;
                    position: relative;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
                }
                .why-join-card::before {
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 0;
                    height: 3px;
                    background: linear-gradient(90deg, #a04ff4, #ffb428);
                    transition: width 0.4s ease;
                }
                .why-join-card:hover {
                    transform: translateY(-10px);
                    background: linear-gradient(145deg, rgba(46, 25, 75, 0.6) 0%, rgba(20, 10, 40, 0.9) 100%);
                    border-color: rgba(160, 79, 244, 0.4);
                    box-shadow: 0 20px 40px rgba(160, 79, 244, 0.2);
                }
                .why-join-card:hover::before {
                    width: 100%;
                }
                .why-join-icon {
                    font-size: 2.8rem;
                    color: #a04ff4;
                    margin-bottom: 1.2rem;
                    padding: 15px;
                    background: rgba(160, 79, 244, 0.1);
                    border-radius: 12px;
                    border: 1px solid rgba(160, 79, 244, 0.2);
                    transition: transform 0.3s ease;
                }
                .why-join-card:hover .why-join-icon {
                    transform: scale(1.1) rotate(5deg);
                    background: rgba(160, 79, 244, 0.2);
                }
                .why-join-title {
                    font-weight: 600;
                    color: #fff;
                    font-size: 1.2rem;
                    letter-spacing: 0.5px;
                    margin: 0;
                }

                /* --- Job Listings Section --- */
                .job-listings-section {
                    padding: 80px 0;
                    background: rgba(17, 7, 35, 0.5);
                    position: relative;
                    z-index: 2;
                }
                .job-listings-container {
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                    max-width: 800px;
                    margin: 0 auto;
                }
                .job-card {
                    background: rgba(26, 15, 45, 0.6);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    border-radius: 16px;
                    padding: 30px;
                    transition: all 0.3s ease;
                    backdrop-filter: blur(10px);
                }
                .job-card:hover {
                    background: rgba(36, 20, 60, 0.7);
                    border-color: rgba(160, 79, 244, 0.4);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
                    transform: translateY(-3px);
                }
                .job-card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 1rem;
                    flex-wrap: wrap;
                    gap: 10px;
                }
                .job-title {
                    font-size: 1.4rem;
                    font-weight: 600;
                    color: #fff;
                    margin: 0;
                    letter-spacing: 0.2px;
                }
                .job-location {
                    background-color: rgba(160, 79, 244, 0.15);
                    color: #c084fc;
                    padding: 6px 14px;
                    border-radius: 50px;
                    border: 1px solid rgba(160, 79, 244, 0.3);
                    font-size: 0.85rem;
                    font-weight: 600;
                    flex-shrink: 0;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                }
                .job-desc {
                    color: #a0a0a0;
                    margin-bottom: 1.5rem;
                    line-height: 1.7;
                    letter-spacing: 0.3px;
                }
                .job-apply-button {
                    display: inline-block;
                    color: #000;
                    text-decoration: none;
                    font-weight: 600;
                    background: linear-gradient(90deg, #ffb428, #a04ff4);
                    padding: 10px 24px;
                    border-radius: 8px;
                    transition: opacity 0.3s ease, transform 0.3s ease;
                    letter-spacing: 0.5px;
                }
                .job-apply-button:hover {
                    opacity: 0.9;
                    transform: translateY(-2px);
                    color: #fff;
                }

                /* --- No Openings State --- */
                .no-openings-card {
                    background: rgba(26, 15, 45, 0.4);
                    border: 1px dashed rgba(160, 79, 244, 0.4);
                    border-radius: 20px;
                    padding: 60px 40px;
                    text-align: center;
                    transition: all 0.4s ease;
                    backdrop-filter: blur(10px);
                }
                .no-openings-card:hover {
                    border-style: solid;
                    background: rgba(36, 20, 60, 0.6);
                    box-shadow: 0 15px 40px rgba(160, 79, 244, 0.15);
                    transform: translateY(-5px);
                }
                .no-openings-icon {
                    font-size: 4rem;
                    color: #a04ff4;
                    margin-bottom: 1.5rem;
                    opacity: 0.9;
                    animation: floatIcon 3s ease-in-out infinite;
                }
                @keyframes floatIcon {
                    0% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                    100% { transform: translateY(0); }
                }
                .no-openings-title {
                    font-size: 2rem;
                    color: #fff;
                    font-weight: 700;
                    margin-bottom: 1rem;
                    letter-spacing: -0.5px;
                }
                .no-openings-desc {
                    color: #a0a0a0;
                    font-size: 1.1rem;
                    max-width: 600px;
                    margin: 0 auto 2rem auto;
                    line-height: 1.7;
                    letter-spacing: 0.3px;
                }
                .no-openings-contact {
                    color: #9ca3af;
                    font-size: 1rem;
                    letter-spacing: 0.2px;
                }
                .no-openings-contact a {
                    color: #ffb428;
                    text-decoration: none;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    padding: 2px 5px;
                }
                .no-openings-contact a:hover {
                    color: #fff;
                    text-shadow: 0 0 10px rgba(255, 180, 40, 0.5);
                }

                /* --- Perks Section --- */
                .perks-section {
                    padding: 80px 0;
                    position: relative;
                    z-index: 2;
                }
                .perk-card {
                    padding: 24px;
                    border-radius: 16px;
                    background: rgba(26, 15, 45, 0.4);
                    border: 1px solid rgba(255, 255, 255, 0.05);
                    border-left: 4px solid #feb52b;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    gap: 20px;
                    backdrop-filter: blur(10px);
                }
                .perk-card:hover {
                    transform: translateY(-5px);
                    background: rgba(36, 20, 60, 0.7);
                    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
                    border-color: rgba(254, 181, 43, 0.3);
                    border-left: 6px solid #a04ff4;
                }
                .perk-icon {
                    font-size: 2.2rem;
                    color: #feb52b;
                    transition: color 0.3s ease;
                }
                .perk-card:hover .perk-icon {
                    color: #a04ff4;
                }
                .perk-text {
                    margin-bottom: 0;
                    font-weight: 600;
                    font-size: 1.1rem;
                    color: #e0e0e0;
                    letter-spacing: 0.3px;
                    word-spacing: 1px;
                }
                
                /* --- Responsive --- */
                @media (max-width: 768px) {
                    .career-hero { padding: 80px 15px 40px; }
                    .career-hero-title { font-size: 2.5rem; }
                    .why-join-section, .job-listings-section, .perks-section {
                        padding: 60px 15px;
                    }
                    .section-title { font-size: 2.2rem; margin-bottom: 2.5rem; }
                    .no-openings-card { padding: 40px 20px; }
                    .no-openings-icon { font-size: 3rem; }
                    .no-openings-title { font-size: 1.6rem; }
                }
            `}</style>
        </>
    );
};

export default Career;